import { Checkbox, Grid, FormControlLabel, Button, Box } from "@mui/material"
import { ChangeEvent, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { CancelButton } from "../../../components/CancelButton/CancelButton"
import { acceptTermsAndCondition, getTermsAndConditions, TermsAndConditionData } from "../../../services/ntuc/memberService/termsAndConditions"
import { Status } from "../../../services/ntuc/Model"
import { useSignupStore } from "../../../store/signup/UserSignupStore"
import { SignupRoute, SignupRouteParams } from "../SignupFlow/SignupFlow"
import { trackSignUpStep } from "../../../helpers/gtm"
const TermsAndConditionsPage = (props: SignupRouteParams) => {
    const { onNavigateTo } = props
    const { t } = useTranslation(`signup`)

    const [termsAndConditions, setTermsAndConditions] = useState<TermsAndConditionData | undefined>(undefined)
    const [accept, setAccept] = useState(false)

    const tncDeclaration = t(`tncDeclaration`)
    const [state] = useSignupStore()

    useEffect(() => {
        if (state.membershipId) {
            getTermsAndConditions(state.membershipId)
                .then(response => response.data.content)
                .then(setTermsAndConditions)
                .catch(console.error)
        } else {
            console.log(`No membership ID found`)
        }
    }, [state.membershipId])

    const handleCheckBoxOnChange = (_event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
        setAccept(checked)
    }
    const handleNextButtonOnClick = () => {
        if (state.membershipId && termsAndConditions?.version) {
            acceptTermsAndCondition(state.membershipId, termsAndConditions.version)
                .then(response => {
                    if (response.data.metadata.status === Status.SUCCESS) {
                        trackSignUpStep(`TermsAndConditions`)
                        onNavigateTo(SignupRoute.Payment)
                    }
                })
                .catch(console.error)
        } else {
            console.log(`No membership ID found`)
        }
    }

    const handleBackButtonClick = () => {
        onNavigateTo(SignupRoute.Review)
    }

    const Terms = () => {
        return (
            <Box>
                <div dangerouslySetInnerHTML={{ __html: termsAndConditions?.content ?? `` }} />
            </Box>
        )
    }

    const NextButton = () => {
        return (
            <Button
                disabled={!accept}
                variant="contained"
                color="primary"
                size="large"
                onClick={handleNextButtonOnClick}
            >
                {t(`next`)}
            </Button>
        )
    }

    const ConsentCheckBox = () => <Checkbox checked={accept} onChange={handleCheckBoxOnChange} />

    const ConsentView = () => {
        if (termsAndConditions?.content) {
            return (
                <Grid item container rowSpacing={2} direction="column" justifyContent="center">
                    <Grid item>
                        <FormControlLabel control={<ConsentCheckBox />} label={tncDeclaration} />
                    </Grid>
                    <Grid container item direction="row" justifyContent="space-evenly" alignItems="center">
                        <CancelButton onClick={handleBackButtonClick} />
                        <NextButton />
                    </Grid>
                </Grid>
            )
        } else {
            return (<div />)
        }
    }

    return (
        <Grid container padding={2} rowSpacing={2} alignContent={`center`}>
            <Terms />
            <ConsentView />
        </Grid>
    )
}

export default TermsAndConditionsPage